// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Alert-module__font-s-10___SfvXy {
  font-size: 10px !important;
}

.Alert-module__font-s-12___fDoZL {
  font-size: 12px !important;
}

.Alert-module__font-s-13___E4od9 {
  font-size: 13px !important;
}

.Alert-module__font-s-14___BSHZf {
  font-size: 14px !important;
}

.Alert-module__font-s-15___kWS2Z {
  font-size: 15px !important;
}

.Alert-module__font-s-16___Ut9X6 {
  font-size: 16px !important;
}

.Alert-module__font-s-18___zo9WO {
  font-size: 18px !important;
}

.Alert-module__font-s-20___mqEic {
  font-size: 20px !important;
}

.Alert-module__font-s-22___jP1EA {
  font-size: 22px !important;
}

.Alert-module__font-s-28___QqzMt {
  font-size: 28px !important;
}

.Alert-module__font-w-400___mCja6 {
  font-weight: 400 !important;
}

.Alert-module__font-w-500___Kqjhf {
  font-weight: 500 !important;
}

.Alert-module__font-w-600___KYI9d {
  font-weight: 600 !important;
}

.Alert-module__font-w-700___zvbck {
  font-weight: 700 !important;
}

.Alert-module__p-5___xij5h {
  padding: 5px !important;
}

.Alert-module__p-12___tbGHE {
  padding: 12px !important;
}

.Alert-module__p-16___O7Pxu {
  padding: 16px !important;
}

.Alert-module__p-30___NqvBm {
  padding: 30px !important;
}

.Alert-module__p-b-0___M1gUB {
  padding-bottom: 0 !important;
}

.Alert-module__p-b-5___YlWWm {
  padding-bottom: 5px !important;
}

.Alert-module__p-b-10___ip41h {
  padding-bottom: 10px !important;
}

.Alert-module__p-b-12___ztQlU {
  padding-bottom: 12px !important;
}

.Alert-module__p-b-16___S_hUr {
  padding-bottom: 16px !important;
}

.Alert-module__p-b-18___ZncXY {
  padding-bottom: 18px !important;
}

.Alert-module__p-b-20___P1d92 {
  padding-bottom: 20px !important;
}

.Alert-module__p-b-25___xOhUX {
  padding-bottom: 25px !important;
}

.Alert-module__p-b-30___LhuxO {
  padding-bottom: 30px !important;
}

.Alert-module__p-b-50___GskzT {
  padding-bottom: 50px !important;
}

.Alert-module__p-t-0___F99xq {
  padding-top: 0 !important;
}

.Alert-module__p-t-12___ooysq {
  padding-top: 12px !important;
}

.Alert-module__p-t-16___K32eL {
  padding-top: 16px !important;
}

.Alert-module__p-t-18___bznx5 {
  padding-top: 18px !important;
}

.Alert-module__p-t-20___jZOMk {
  padding-top: 20px !important;
}

.Alert-module__p-t-30___kdcUl {
  padding-top: 30px !important;
}

.Alert-module__p-t-40___D42jR {
  padding-top: 40px !important;
}

.Alert-module__p-t-50___nSWLQ {
  padding-top: 50px !important;
}

.Alert-module__p-l-20___bYLIG {
  padding-left: 20px !important;
}

.Alert-module__p-l-30___J8zTc {
  padding-left: 30px !important;
}

.Alert-module__p-l-40___O1b7u {
  padding-left: 40px !important;
}

.Alert-module__p-r-16___QudGz {
  padding-right: 16px !important;
}

.Alert-module__p-r-20___cr1hh {
  padding-right: 20px !important;
}

.Alert-module__p-r-30___M5Zgd {
  padding-right: 30px !important;
}

.Alert-module__p-r-50___BoazJ {
  padding-right: 50px !important;
}

.Alert-module__p-r-60___YPfZg {
  padding-right: 60px !important;
}

.Alert-module__m-b-1___BsmMI {
  margin-bottom: 1px !important;
}

.Alert-module__m-b-2___fblbv {
  margin-bottom: 2px !important;
}

.Alert-module__m-b-6___wfxij {
  margin-bottom: 6px !important;
}

.Alert-module__m-b-8___ejuu6 {
  margin-bottom: 8px !important;
}

.Alert-module__m-b-10___YAS0n {
  margin-bottom: 10px !important;
}

.Alert-module__m-b-14___syFad {
  margin-bottom: 14px !important;
}

.Alert-module__m-b-16___bcU5F {
  margin-bottom: 16px !important;
}

.Alert-module__m-b-20___l5Yy3 {
  margin-bottom: 20px !important;
}

.Alert-module__m-b-22___ndm9H {
  margin-bottom: 22px !important;
}

.Alert-module__m-b-24___pbfQM {
  margin-bottom: 24px !important;
}

.Alert-module__m-b-30___SxXkh {
  margin-bottom: 30px !important;
}

.Alert-module__m-b-32___VZWxC {
  margin-bottom: 32px !important;
}

.Alert-module__m-b-40____gEc1 {
  margin-bottom: 40px !important;
}

.Alert-module__m-t-2___ass6k {
  margin-top: 2px !important;
}

.Alert-module__m-t-3___xX_wt {
  margin-top: 3px !important;
}

.Alert-module__m-t-4___jHhRi {
  margin-top: 4px !important;
}

.Alert-module__m-t-5___XtbbW {
  margin-top: 5px !important;
}

.Alert-module__m-t-8___lZX37 {
  margin-top: 8px !important;
}

.Alert-module__m-t-10___mvzct {
  margin-top: 10px !important;
}

.Alert-module__m-t-15___hn8h5 {
  margin-top: 15px !important;
}

.Alert-module__m-t-16___S6_hz {
  margin-top: 16px !important;
}

.Alert-module__m-t-20___v7fAX {
  margin-top: 20px !important;
}

.Alert-module__m-t-22___QOXY4 {
  margin-top: 22px !important;
}

.Alert-module__m-t-30___KrXvr {
  margin-top: 30px !important;
}

.Alert-module__m-t-32___Qr8E8 {
  margin-top: 32px !important;
}

.Alert-module__m-l-auto___LjQ1r {
  margin-left: auto !important;
}

.Alert-module__m-l-4___euPYS {
  margin-left: 4px !important;
}

.Alert-module__m-l-5___e64Ld {
  margin-left: 5px !important;
}

.Alert-module__m-l-6___ZET_G {
  margin-left: 6px !important;
}

.Alert-module__m-l-8___xHz0I {
  margin-left: 8px !important;
}

.Alert-module__m-l-10___Pp9cJ {
  margin-left: 10px !important;
}

.Alert-module__m-l-16___qEI4U {
  margin-left: 16px !important;
}

.Alert-module__m-l-20___HmIuw {
  margin-left: 20px !important;
}

.Alert-module__m-l-24___nk_lA {
  margin-left: 24px !important;
}

.Alert-module__m-l-30___wwst8 {
  margin-left: 30px !important;
}

.Alert-module__m-l-35___lmYJb {
  margin-left: 35px !important;
}

.Alert-module__m-l-40___v9oTR {
  margin-left: 40px !important;
}

.Alert-module__m-r-8___BZ8Jz {
  margin-right: 8px !important;
}

.Alert-module__m-r-10___vaGvj {
  margin-right: 10px !important;
}

.Alert-module__m-r-16___HJuSi {
  margin-right: 16px !important;
}

.Alert-module__m-r-20___Jh9Nd {
  margin-right: 20px !important;
}

.Alert-module__m-r-24___wiN7O {
  margin-right: 24px !important;
}

.Alert-module__m-r-30___E4Yy9 {
  margin-right: 30px !important;
}

.Alert-module__m-r-40___qN3y9 {
  margin-right: 40px !important;
}

.Alert-module__border-r-3___c6AMW {
  border-radius: 3px !important;
}

.Alert-module__border-r-4___npbT0 {
  border-radius: 4px !important;
}

.Alert-module__border-r-6___Z9KeH {
  border-radius: 6px !important;
}

.Alert-module__border-r-10___e3qJF {
  border-radius: 10px !important;
}

.Alert-module__border-r-12___pcO1n {
  border-radius: 12px !important;
}

.Alert-module__border-r-16___wZdvk {
  border-radius: 16px !important;
}

.Alert-module__border-r-50___gKZiB {
  border-radius: 50% !important;
}

.Alert-module__primary-border___xua8p {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Alert-module__primary-border-b___adSCU {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Alert-module__primary-border-t___wuzQU {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Alert-module__primary-border-l___Gz8xh {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Alert-module__primary-border-r___lnunN {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Alert-module__secondary-border___d3JcG {
  border: 1px solid #637768;
}

.Alert-module__secondary-border-b___yHBHT {
  border-bottom: 1px solid #637768;
}

.Alert-module__secondary-border-t___OB8I2 {
  border-top: 1px solid #637768;
}

.Alert-module__secondary-border-l___FIAbC {
  border-left: 1px solid #637768;
}

.Alert-module__secondary-border-r___z6Pb8 {
  border-right: 1px solid #637768;
}

.Alert-module__gap-0___zKwhd {
  gap: 0 !important;
}

.Alert-module__gap-2___YquB1 {
  gap: 2px !important;
}

.Alert-module__gap-4___Y4OF1 {
  gap: 4px !important;
}

.Alert-module__gap-5___rJdoP {
  gap: 5px !important;
}

.Alert-module__gap-6___SFiR9 {
  gap: 6px !important;
}

.Alert-module__gap-8___dOkzv {
  gap: 8px !important;
}

.Alert-module__gap-10___hJTes {
  gap: 10px !important;
}

.Alert-module__gap-12___utV2Y {
  gap: 12px !important;
}

.Alert-module__gap-14___ySibM {
  gap: 14px !important;
}

.Alert-module__gap-16___KqI4c {
  gap: 16px !important;
}

.Alert-module__gap-18___Fa3Rs {
  gap: 18px !important;
}

.Alert-module__gap-20___c28ou {
  gap: 20px !important;
}

.Alert-module__gap-24___roYCY {
  gap: 24px !important;
}

.Alert-module__gap-26___KmKFi {
  gap: 26px !important;
}

.Alert-module__gap-30___fo90k {
  gap: 30px !important;
}

.Alert-module__gap-32___ljNaz {
  gap: 32px !important;
}

.Alert-module__gap-40___i64Br {
  gap: 40px !important;
}

.Alert-module__gap-50___Y1Py2 {
  gap: 50px !important;
}

.Alert-module__flex-1___KvFoC {
  flex: 1;
}

.Alert-module__flex-none___dPmf2 {
  flex: none !important;
}

.Alert-module__flex-column___Xkhm3 {
  display: flex;
  flex-direction: column !important;
}

.Alert-module__flex-row___VHptT {
  display: flex;
  flex-direction: row !important;
}

.Alert-module__vertically-centered___j4Zc4 {
  display: flex;
  align-items: center !important;
}

.Alert-module__horizontally-centered___PyVc7 {
  display: flex;
  justify-content: center !important;
}

.Alert-module__horizontally-end___BZTTk {
  display: flex;
  justify-content: end !important;
}

.Alert-module__vertically-start___sj8Jx {
  display: flex;
  align-items: start !important;
}

.Alert-module__space-between___lPzT_ {
  display: flex;
  justify-content: space-between !important;
}

.Alert-module__flex-wrap___U3pH4 {
  flex-wrap: wrap !important;
}

.Alert-module__height-100___uE4Rq {
  height: 100%;
}

.Alert-module__width-50___S7WW8 {
  width: 50% !important;
}

.Alert-module__width-100___PGKkg {
  width: 100%;
}

.Alert-module__cursor-pointer___LQnh_ {
  cursor: pointer;
}

.Alert-module__cursor-not-allowed___n_FBr {
  cursor: not-allowed !important;
}

.Alert-module__absolute-centered___N7O7g {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Alert-module__absolute___JmF37 {
  position: absolute;
}

.Alert-module__relative___vBa6p {
  position: relative;
}

.Alert-module__fixed___V0haZ {
  position: fixed;
}

.Alert-module__visible___PrYE_ {
  opacity: 1;
}

.Alert-module__invisible____o1NE {
  opacity: 0;
}

.Alert-module__col-90___CD3Qu {
  width: 90% !important;
}

.Alert-module__col-auto___sKlx2 {
  width: auto !important;
}

.Alert-module__medical-tabs___FCCXe {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Alert-module__medical-table-new___wQf_2 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Alert-module__medical-table-new___wQf_2:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Alert-module__medical-table-new___wQf_2::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Alert-module__medical-table-new___wQf_2::-webkit-scrollbar-track {
  display: none;
}
.Alert-module__medical-table-new___wQf_2.Alert-module__no-pagination___nA533 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Alert-module__medical-table-new___wQf_2.Alert-module__no-pagination___nA533:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Alert-module__medical-table-new___wQf_2.Alert-module__no-pagination___nA533::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Alert-module__medical-table-new___wQf_2.Alert-module__no-pagination___nA533::-webkit-scrollbar-track {
  display: none;
}

.Alert-module__medical-table-empty___tvW1r {
  padding: 14px 40px !important;
}

.Alert-module__icon-btn___LS7hC {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Alert-module__search-icon___PJXjh {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Alert-module__disable-select___DTWAC {
  user-select: none;
}

.Alert-module__break-word___ZKECC {
  word-break: break-word;
}

.Alert-module__popup-clear-btn___pzqX5 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Alert-module__scroll-m-b-20___br9Wq {
  scroll-margin-bottom: 20px;
}

.Alert-module__alert___MM_Gy {
  padding: 14px 20px;
  border-radius: 8px;
  box-shadow: 1px 4px 20px 0 rgba(0, 0, 0, 0.07);
}
.Alert-module__alert___MM_Gy.Alert-module__success___LEv1F {
  background-color: #375844;
}
.Alert-module__alert___MM_Gy.Alert-module__error___ukyVp {
  background-color: #f06c67;
}
.Alert-module__alert___MM_Gy.Alert-module__warning___ZqRnt {
  background-color: #f1bf72;
}
.Alert-module__alert___MM_Gy .Alert-module__wrapper___RNL1w {
  display: flex;
  align-items: center;
}
.Alert-module__alert___MM_Gy .Alert-module__wrapper___RNL1w .Alert-module__textContainer___BivDD {
  display: flex;
  flex-direction: column;
  flex: 1;
  color: white;
  gap: 4px;
  justify-content: center;
}
.Alert-module__alert___MM_Gy .Alert-module__wrapper___RNL1w .Alert-module__textContainer___BivDD .Alert-module__title___uwfEl {
  font-size: 16px;
  font-weight: 600;
}
.Alert-module__alert___MM_Gy .Alert-module__wrapper___RNL1w .Alert-module__textContainer___BivDD .Alert-module__message___uHix9 {
  font-size: 14px;
  font-weight: 500;
}
.Alert-module__alert___MM_Gy .Alert-module__wrapper___RNL1w .Alert-module__closeBtn___aeR9v {
  width: 16px;
  height: 16px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/base/AlertGroup/Alert/Alert.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;EACA,kBAAA;EACA,8CAAA;AA8pBF;AA5pBE;EACE,yBAAA;AA8pBJ;AA3pBE;EACE,yBAAA;AA6pBJ;AA1pBE;EACE,yBAAA;AA4pBJ;AAzpBE;EACE,aAAA;EACA,mBAAA;AA2pBJ;AAzpBI;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;EACA,QAAA;EACA,uBAAA;AA2pBN;AAzpBM;EACE,eAAA;EACA,gBAAA;AA2pBR;AAxpBM;EACE,eAAA;EACA,gBAAA;AA0pBR;AAtpBI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAwpBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.alert {\n  padding: 14px 20px;\n  border-radius: 8px;\n  box-shadow: 1px 4px 20px 0 rgba(0, 0, 0, 0.07);\n\n  &.success {\n    background-color: get-color(greenNew, dark);\n  }\n\n  &.error {\n    background-color: get-color(redNew, medium-dark);\n  }\n\n  &.warning {\n    background-color: get-color(orangeNew);\n  }\n\n  .wrapper {\n    display: flex;\n    align-items: center;\n\n    .textContainer {\n      display: flex;\n      flex-direction: column;\n      flex: 1;\n      color: white;\n      gap: 4px;\n      justify-content: center;\n\n      .title {\n        font-size: 16px;\n        font-weight: 600;\n      }\n\n      .message {\n        font-size: 14px;\n        font-weight: 500;\n      }\n    }\n\n    .closeBtn {\n      width: 16px;\n      height: 16px;\n      cursor: pointer;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Alert-module__font-s-10___SfvXy`,
	"fontS12": `Alert-module__font-s-12___fDoZL`,
	"fontS13": `Alert-module__font-s-13___E4od9`,
	"fontS14": `Alert-module__font-s-14___BSHZf`,
	"fontS15": `Alert-module__font-s-15___kWS2Z`,
	"fontS16": `Alert-module__font-s-16___Ut9X6`,
	"fontS18": `Alert-module__font-s-18___zo9WO`,
	"fontS20": `Alert-module__font-s-20___mqEic`,
	"fontS22": `Alert-module__font-s-22___jP1EA`,
	"fontS28": `Alert-module__font-s-28___QqzMt`,
	"fontW400": `Alert-module__font-w-400___mCja6`,
	"fontW500": `Alert-module__font-w-500___Kqjhf`,
	"fontW600": `Alert-module__font-w-600___KYI9d`,
	"fontW700": `Alert-module__font-w-700___zvbck`,
	"p5": `Alert-module__p-5___xij5h`,
	"p12": `Alert-module__p-12___tbGHE`,
	"p16": `Alert-module__p-16___O7Pxu`,
	"p30": `Alert-module__p-30___NqvBm`,
	"pB0": `Alert-module__p-b-0___M1gUB`,
	"pB5": `Alert-module__p-b-5___YlWWm`,
	"pB10": `Alert-module__p-b-10___ip41h`,
	"pB12": `Alert-module__p-b-12___ztQlU`,
	"pB16": `Alert-module__p-b-16___S_hUr`,
	"pB18": `Alert-module__p-b-18___ZncXY`,
	"pB20": `Alert-module__p-b-20___P1d92`,
	"pB25": `Alert-module__p-b-25___xOhUX`,
	"pB30": `Alert-module__p-b-30___LhuxO`,
	"pB50": `Alert-module__p-b-50___GskzT`,
	"pT0": `Alert-module__p-t-0___F99xq`,
	"pT12": `Alert-module__p-t-12___ooysq`,
	"pT16": `Alert-module__p-t-16___K32eL`,
	"pT18": `Alert-module__p-t-18___bznx5`,
	"pT20": `Alert-module__p-t-20___jZOMk`,
	"pT30": `Alert-module__p-t-30___kdcUl`,
	"pT40": `Alert-module__p-t-40___D42jR`,
	"pT50": `Alert-module__p-t-50___nSWLQ`,
	"pL20": `Alert-module__p-l-20___bYLIG`,
	"pL30": `Alert-module__p-l-30___J8zTc`,
	"pL40": `Alert-module__p-l-40___O1b7u`,
	"pR16": `Alert-module__p-r-16___QudGz`,
	"pR20": `Alert-module__p-r-20___cr1hh`,
	"pR30": `Alert-module__p-r-30___M5Zgd`,
	"pR50": `Alert-module__p-r-50___BoazJ`,
	"pR60": `Alert-module__p-r-60___YPfZg`,
	"mB1": `Alert-module__m-b-1___BsmMI`,
	"mB2": `Alert-module__m-b-2___fblbv`,
	"mB6": `Alert-module__m-b-6___wfxij`,
	"mB8": `Alert-module__m-b-8___ejuu6`,
	"mB10": `Alert-module__m-b-10___YAS0n`,
	"mB14": `Alert-module__m-b-14___syFad`,
	"mB16": `Alert-module__m-b-16___bcU5F`,
	"mB20": `Alert-module__m-b-20___l5Yy3`,
	"mB22": `Alert-module__m-b-22___ndm9H`,
	"mB24": `Alert-module__m-b-24___pbfQM`,
	"mB30": `Alert-module__m-b-30___SxXkh`,
	"mB32": `Alert-module__m-b-32___VZWxC`,
	"mB40": `Alert-module__m-b-40____gEc1`,
	"mT2": `Alert-module__m-t-2___ass6k`,
	"mT3": `Alert-module__m-t-3___xX_wt`,
	"mT4": `Alert-module__m-t-4___jHhRi`,
	"mT5": `Alert-module__m-t-5___XtbbW`,
	"mT8": `Alert-module__m-t-8___lZX37`,
	"mT10": `Alert-module__m-t-10___mvzct`,
	"mT15": `Alert-module__m-t-15___hn8h5`,
	"mT16": `Alert-module__m-t-16___S6_hz`,
	"mT20": `Alert-module__m-t-20___v7fAX`,
	"mT22": `Alert-module__m-t-22___QOXY4`,
	"mT30": `Alert-module__m-t-30___KrXvr`,
	"mT32": `Alert-module__m-t-32___Qr8E8`,
	"mLAuto": `Alert-module__m-l-auto___LjQ1r`,
	"mL4": `Alert-module__m-l-4___euPYS`,
	"mL5": `Alert-module__m-l-5___e64Ld`,
	"mL6": `Alert-module__m-l-6___ZET_G`,
	"mL8": `Alert-module__m-l-8___xHz0I`,
	"mL10": `Alert-module__m-l-10___Pp9cJ`,
	"mL16": `Alert-module__m-l-16___qEI4U`,
	"mL20": `Alert-module__m-l-20___HmIuw`,
	"mL24": `Alert-module__m-l-24___nk_lA`,
	"mL30": `Alert-module__m-l-30___wwst8`,
	"mL35": `Alert-module__m-l-35___lmYJb`,
	"mL40": `Alert-module__m-l-40___v9oTR`,
	"mR8": `Alert-module__m-r-8___BZ8Jz`,
	"mR10": `Alert-module__m-r-10___vaGvj`,
	"mR16": `Alert-module__m-r-16___HJuSi`,
	"mR20": `Alert-module__m-r-20___Jh9Nd`,
	"mR24": `Alert-module__m-r-24___wiN7O`,
	"mR30": `Alert-module__m-r-30___E4Yy9`,
	"mR40": `Alert-module__m-r-40___qN3y9`,
	"borderR3": `Alert-module__border-r-3___c6AMW`,
	"borderR4": `Alert-module__border-r-4___npbT0`,
	"borderR6": `Alert-module__border-r-6___Z9KeH`,
	"borderR10": `Alert-module__border-r-10___e3qJF`,
	"borderR12": `Alert-module__border-r-12___pcO1n`,
	"borderR16": `Alert-module__border-r-16___wZdvk`,
	"borderR50": `Alert-module__border-r-50___gKZiB`,
	"primaryBorder": `Alert-module__primary-border___xua8p`,
	"primaryBorderB": `Alert-module__primary-border-b___adSCU`,
	"primaryBorderT": `Alert-module__primary-border-t___wuzQU`,
	"primaryBorderL": `Alert-module__primary-border-l___Gz8xh`,
	"primaryBorderR": `Alert-module__primary-border-r___lnunN`,
	"secondaryBorder": `Alert-module__secondary-border___d3JcG`,
	"secondaryBorderB": `Alert-module__secondary-border-b___yHBHT`,
	"secondaryBorderT": `Alert-module__secondary-border-t___OB8I2`,
	"secondaryBorderL": `Alert-module__secondary-border-l___FIAbC`,
	"secondaryBorderR": `Alert-module__secondary-border-r___z6Pb8`,
	"gap0": `Alert-module__gap-0___zKwhd`,
	"gap2": `Alert-module__gap-2___YquB1`,
	"gap4": `Alert-module__gap-4___Y4OF1`,
	"gap5": `Alert-module__gap-5___rJdoP`,
	"gap6": `Alert-module__gap-6___SFiR9`,
	"gap8": `Alert-module__gap-8___dOkzv`,
	"gap10": `Alert-module__gap-10___hJTes`,
	"gap12": `Alert-module__gap-12___utV2Y`,
	"gap14": `Alert-module__gap-14___ySibM`,
	"gap16": `Alert-module__gap-16___KqI4c`,
	"gap18": `Alert-module__gap-18___Fa3Rs`,
	"gap20": `Alert-module__gap-20___c28ou`,
	"gap24": `Alert-module__gap-24___roYCY`,
	"gap26": `Alert-module__gap-26___KmKFi`,
	"gap30": `Alert-module__gap-30___fo90k`,
	"gap32": `Alert-module__gap-32___ljNaz`,
	"gap40": `Alert-module__gap-40___i64Br`,
	"gap50": `Alert-module__gap-50___Y1Py2`,
	"flex1": `Alert-module__flex-1___KvFoC`,
	"flexNone": `Alert-module__flex-none___dPmf2`,
	"flexColumn": `Alert-module__flex-column___Xkhm3`,
	"flexRow": `Alert-module__flex-row___VHptT`,
	"verticallyCentered": `Alert-module__vertically-centered___j4Zc4`,
	"horizontallyCentered": `Alert-module__horizontally-centered___PyVc7`,
	"horizontallyEnd": `Alert-module__horizontally-end___BZTTk`,
	"verticallyStart": `Alert-module__vertically-start___sj8Jx`,
	"spaceBetween": `Alert-module__space-between___lPzT_`,
	"flexWrap": `Alert-module__flex-wrap___U3pH4`,
	"height100": `Alert-module__height-100___uE4Rq`,
	"width50": `Alert-module__width-50___S7WW8`,
	"width100": `Alert-module__width-100___PGKkg`,
	"cursorPointer": `Alert-module__cursor-pointer___LQnh_`,
	"cursorNotAllowed": `Alert-module__cursor-not-allowed___n_FBr`,
	"absoluteCentered": `Alert-module__absolute-centered___N7O7g`,
	"absolute": `Alert-module__absolute___JmF37`,
	"relative": `Alert-module__relative___vBa6p`,
	"fixed": `Alert-module__fixed___V0haZ`,
	"visible": `Alert-module__visible___PrYE_`,
	"invisible": `Alert-module__invisible____o1NE`,
	"col90": `Alert-module__col-90___CD3Qu`,
	"colAuto": `Alert-module__col-auto___sKlx2`,
	"medicalTabs": `Alert-module__medical-tabs___FCCXe`,
	"medicalTableNew": `Alert-module__medical-table-new___wQf_2`,
	"noPagination": `Alert-module__no-pagination___nA533`,
	"medicalTableEmpty": `Alert-module__medical-table-empty___tvW1r`,
	"iconBtn": `Alert-module__icon-btn___LS7hC`,
	"searchIcon": `Alert-module__search-icon___PJXjh`,
	"disableSelect": `Alert-module__disable-select___DTWAC`,
	"breakWord": `Alert-module__break-word___ZKECC`,
	"popupClearBtn": `Alert-module__popup-clear-btn___pzqX5`,
	"scrollMB20": `Alert-module__scroll-m-b-20___br9Wq`,
	"alert": `Alert-module__alert___MM_Gy`,
	"success": `Alert-module__success___LEv1F`,
	"error": `Alert-module__error___ukyVp`,
	"warning": `Alert-module__warning___ZqRnt`,
	"wrapper": `Alert-module__wrapper___RNL1w`,
	"textContainer": `Alert-module__textContainer___BivDD`,
	"title": `Alert-module__title___uwfEl`,
	"message": `Alert-module__message___uHix9`,
	"closeBtn": `Alert-module__closeBtn___aeR9v`
};
module.exports = ___CSS_LOADER_EXPORT___;
